import React from "react";

export const Image = ({ src, alt, loading = "lazy", fetchPriority, ...props }) => {
  if (!src) {
    return null;
  }

  return <img
    src={src}
    alt={alt}
    loading={loading}
    fetchpriority={fetchPriority}
    {...props}
  />
};
